<div [ngClass]="statusColor" class="pill">
    {{statusDisplay}}
</div>
